import { useEffect, useState } from "react";
import cssIf from "../../../scripts/helpers/class.add.if";
import useGlobal from "../../../store";
import "./popup.scss";
import Button from "../../components/button";

const Popup = ({ children, isOpened, animateClose, withoutBackground = false }) => {

  return (

    !isOpened ? null :
    
    <div className = {`popup-container ${ cssIf( isOpened, `popup-container--opened`) }`}>

      <div className = "popup-background" />

      <div className = {`popup ${ cssIf( withoutBackground, `popup--without-background`) } ${ cssIf( animateClose, `zoomOut`) }`}>

        { children }

      </div>
      
    </div>

  );

}

const PopupTitle = ({ children }) => (

  <div className = "popup__title">{ children }</div>

);

const PopupActionButtons = ({ confirm = () => {}, cancel = () => {}, confirmText = "OK", cancelText = "Отмена", confirmDisabled = false, cancelDisabled = false, hideCancel = false }) => (

  <div className = "popup__action_buttons w-100 flex items-center justify-end">

    <Button
      
      text = { confirmText }
      color = "blue"
      action = { confirm }
      disabled = { confirmDisabled }

    />

    { !hideCancel &&
    
      <Button
        
        text = { cancelText }
        color = "gray"
        action = { cancel }
        disabled = { cancelDisabled }

      />
      
    }
  
  </div>

);

const usePopup = ({ name, content, settings = {} }) => {

  const {

    withoutBackground = false,

  } = settings;

  const [ globalState, globalActions ] = useGlobal();
  const { popup_opened, popup_animate_close } = globalState;
  const { popup } = globalActions;

  const show = () => popup.show( name );
  const hide = () => popup.hide();

  const initialize = (

    <Popup 
      isOpened = { popup_opened === name }
      animateClose = { popup_animate_close }
      withoutBackground = { withoutBackground }
    >

      { content }

    </Popup>

  )

  // return [ show, ThisPopup ]
  return {
    show, 
    hide,
    initialize
  }

}

// const PopupTitle = () =>

export {

  usePopup,
  PopupTitle,
  PopupActionButtons,

}